import { render, staticRenderFns } from "./OvRevenueChart.vue?vue&type=template&id=3fbe97ef&scoped=true&"
import script from "./OvRevenueChart.vue?vue&type=script&lang=js&"
export * from "./OvRevenueChart.vue?vue&type=script&lang=js&"
import style0 from "./OvRevenueChart.vue?vue&type=style&index=0&id=3fbe97ef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fbe97ef",
  null
  
)

export default component.exports